export const URLS = {
  HOME: "/",
  SUMMARY: "/summary",
  PAYMENT_SUCCESS: "/payment-success",
  PAYMENT_CANCEL: "/payment-cancel",
};
